const Vue = window.Vue;
const $ = window.jQuery;
const swal = window.swal;
const _ = window._;

const VUE_APP_ID = 'property-search-app';
import PropertySearchStore from '@vue/store/modules/property-search/store';
import { mapMutations, mapGetters, mapActions, mapState } from 'vuex';
import { cleanMlsDisclaimer, getDataObject, convertField, getCookie } from '@vue/store/helpers.js';
import fieldTypes from '@assets/data/property-search-field-types';
import buildingTypes from '@assets/data/building-types';
import BaseStoreMixin from '@vue/mixins/base-store-mixin';
import PropertySearchMixin from '@vue/mixins/property-search-mixin';
import PropertySearchMapMixin from '@vue/mixins/property-search-map-mixin';

import PropertySearchFilters from '@vue/components/rwps/PropertySearchFilters.vue';
import PropertySearchFiltersDrawer from '@vue/components/rwps/PropertySearchFiltersDrawer.vue';
import PropertySearchMap from '@vue/components/rwps/PropertySearchMap.vue';
import SortByControl from '@vue/components/rwps/SortByControl.vue';
import FiltersList from '@vue/components/rwps/FiltersList.vue';
import PropertyPhotoCard from '@vue/components/properties/PropertyPhotoCard.vue';
import Pagination from '@vue/components/Pagination.vue';

import { defaultZoomLevels } from '@vue/components/google-maps/constants/mapSettings';

if(document.getElementById(VUE_APP_ID)){

  new Vue({
    el: '#' + VUE_APP_ID,
    store: PropertySearchStore,
    components: {
      PropertySearchFilters,
      PropertySearchFiltersDrawer,
      PropertySearchMap,
      FiltersList,
      PropertyPhotoCard,
      Pagination,
      SortByControl
    },
    mixins: [
      BaseStoreMixin, 
      PropertySearchMixin, 
      PropertySearchMapMixin
    ],
    data(){
      return {
        buildingTypes,

        shownSavedSearchCTA: false,
        showFilterDrawer: -1,
        mapInitialized: false,
        resultsExpanded: -1,
        filterDrawerActiveCount: 0,
        mobileModeMinWidth: 768,
        filterBarHeight: 0,
        mainHeaderHeight: 0,
        showFilterBarCount: false,

        
      };
    },
    // props: [],
    computed: {
      ...mapState('propertySearchStore', [
        'initialized',
        'mapView',
        'properties',
        'mls_photos',
        'markers',
        'fieldGroups',
        'searchType',
        'selectedLocation',
        'searchParams',
        'mapConfig',
        'listings',
        'highlightedProperty',
        'totalCnt',
        // 'mlsDisclaimerText',
        'mlsDisclaimersTextList',
        'brokerageFootersList',
        'mlsDisclaimers',
        // 'mlsName',
        'mlsNames',
        'mobileMode',
        'locationChanging',
        'queryString',
      ]),
      ...mapGetters('propertySearchStore', [
        'activeFilters',
        'infoWindowPosition',
      ]),

      seoHeadingNoLocation(){
        let text = this.searchType == 'for-sale' 
          ? 'Investment Properties'
          : 'Homes for Rent ';
        return `${text}`;
      },

      seoHeading(){
        if(this.selectedLocation.text){
          let locationText = `${this.selectedLocation.text}`;
          let ending = this.searchType == 'for-sale' 
            ? 'Investment Properties'
            : 'Homes for Rent ';
          return `${locationText} ${ending}`;
        }
        return '';
      },
      
      hasProperties(){
        return this.properties.length > 0;
      },

      hasSelectedLocation(){
        return Math.abs(this.searchParams.lat) && Math.abs(this.searchParams.lng);
      },
        
      numPages(){
        return Math.ceil(this.totalCnt / 100);
      },

      firstPropertyElementId(){
        return (this.properties.length && this.properties[0].id) ? `property-card-${this.properties[0].id}` : '';
      },

      buildingTypeDropdownOptions(){
        if(this.searchType == 'for-sale'){
          return this.buildingTypes.mls;
        } else {
          return this.buildingTypes.internal;
        }
      },

      residentWatchlistUrl(){
        return `/resident-watch-list${this.queryString ? '?' + this.queryString : ''}`
      },

      select2BuildingTypes(){
        let typesToUse = {};
        let types = [];
        if(this.searchType == 'for-sale'){
          typesToUse = {...this.buildingTypes.mls};
        } else {
          typesToUse = {...this.buildingTypes.internal};
        }
        console.log(typesToUse);
        for(let key in typesToUse){
          types.push({
            id: key,
            text: typesToUse[key]
          })
        }
        return types;
      },
      
    },

    beforeMount(){
      this.configureMobile();
    },
        
    created() {
    },
    mounted() {

            
      const vm = this;
            
      vm.updateAppName(VUE_APP_ID);

      if(window.outerWidth < 768){
        vm.addFiltersDrawerMobileFieldGroups();
      }

      Promise.all([vm.getDataObject(), vm.fillInitialValues()])
        .then((response) => {
          const {lat, lng, min_lat, min_lng, max_lat, max_lng} = response[1];
          vm.setupMapConfig();
            // .then((res) => {console.log(res)});
            // .catch((err) => console.warn(err));
          
          setTimeout(() => {
            this.adjustLayoutHeights();

            // just for testing
            // this.toggleShowMoreFilters();
            this.filterBarHeight = document.querySelector('.rwps__filter-bar').clientHeight;
            this.mainHeaderHeight = document.querySelector('.main-header').clientHeight;
          }, 20);
          
          vm.updateInitialized(true);
          

        })
        .catch(error => {
          console.warn(error);
        });

      $(document).on('keyup', (e) => {
        // escape key was hit, and the event bubbled up to the document level
        if(e.keyCode == 27 && vm.showFilterDrawer == 1){
          vm.toggleShowMoreFilters();
        }
      });

      window.onresize = () => this.adjustLayoutHeights();
      window.onscroll = () => this.onScroll();

      const IN_PROD_OR_STAGING = (window.location.hostname == 'www.renterswarehouse.com' || window.location.hostname == 'uat.renterswarehouse.com');


      /* If you go away from the tab and come back, sometimes markers will disappear on Chrome. Alxo if the tab is not active when the map loads, the markers will not show */
      if(IN_PROD_OR_STAGING) window.addEventListener('focus', this.loadNewProperties({}));


      $(document).on('show.bs.dropdown', function () {
        if(vm.showFilterDrawer == 1) vm.toggleShowMoreFilters();
      });
      
      if(this.searchType == 'for-rent'){
        const ctaCookie = getCookie('saved_search_cta');
        const timeToWait = IN_PROD_OR_STAGING ? 50000 : 20000

        if(!ctaCookie){
          setTimeout(() => {
              this.openSavedSearchCTAModal()
          }, timeToWait)
        } else {
          this.shownSavedSearchCTA = true;
        }
      }
      
            
    },
    methods: {
      ...mapMutations('propertySearchStore', [
        'updateInitialized',
        'updateMarkers',
        'updateProperties',
        'updateMlsPhotos',
        'updateSelectedLocation',
        'updateSearchType',
        'updateMapConfig',
        'updateMapConfigCenter',
        'updateMapConfigZoom',
        'updateHighlightedProperty',
        'clearHighlightedProperty',
        'updateFieldGroups',
        'updateTotalCnt',
        'updateSavedPropertySearch',
        // 'updateMlsDisclaimerText',
        'updateMlsDisclaimersTextList',
        'updateSearchParams', // used to reset the location search dropdown during the "confirm removal of selected zipcodes" swal without submitting a new request
        'updateMobileMode',
        // 'updateMlsName',
        'updateMlsNames',
        'addFiltersDrawerMobileFieldGroups',
        'updateLocationChanging'
      ]),
      ...mapActions('propertySearchStore', [
        'changeMapView',
        'changeSearchParams',
        'getProperties',
        'changeSearchType',
        'changeBoundsSearchParams',
        'fillInitialValues',
        // 'getDisclaimer',
        'getDisclaimers',
      ]),

      /**
       * Load New Properties into the Search App
       * @param {L} params 
       */
      loadNewProperties({initial = false, resetPage = false}){
        const vm = this;
        console.log('');
        console.log('loadNewProperties');
        console.trace();
        console.log('');
        
        if(resetPage){
          this.changeSearchParams({page: 1});
        }
        
        if(
          !vm.searchParams.lat 
          || !vm.searchParams.lng
          || !Math.abs(vm.searchParams.min_lat)
          || !Math.abs(vm.searchParams.max_lat)
          || !Math.abs(vm.searchParams.min_lng)
          || !Math.abs(vm.searchParams.max_lng)
          ) {
            
            console.log('');
            console.log('-> do not have needed parameterss to get properties ', vm.searchParams);
            console.log('');
            vm.changeLoading(false); 
            return false;
            
        }

        vm.changeLoading(true);
        // vm.updateMlsDisclaimerText('These listings are courtesy of RentersWarehouse.com');
        vm.updateMlsDisclaimersTextList(['These listings are courtesy of RentersWarehouse.com']);
        let requestParams = {
          initial: initial || false
        };
        this.getProperties(requestParams)
          .then(res => {
            console.log(res);
            const {properties, total_cnt, mls_photos, mls} = res;
            vm.updateProperties(properties);
            vm.scrollResultsToTop();
            // if(params.includeMarkers == undefined || params.includeMarkers == true){ vm.updateMarkers(markers); }
            vm.updateMarkers(properties);
            vm.updateTotalCnt(total_cnt);
            vm.updateMlsPhotos(mls_photos);


            console.log('found mls_photos', this.mls_photos);

            if (Array.isArray(mls) && mls.length > 0) {
              vm.getDisclaimers(mls).then(disclaimers => {
                // vm.updateMlsDisclaimersTextList(disclaimers);
              })
            }
            
            this.changeLoading(false);
            window.initOATooltips();
            
            /**
             * Come back to this
             */
            // this.updateLocationChanging(false);
            
            cleanMlsDisclaimer();
          })
          .catch((err) => {
            let response = err.response;
            vm.changeLoading(false);
            vm.updateInitialized(true);
            if(response && response.status == 500) {
              let alertText = window.location.href.indexOf('renterswarehouse.com') !== -1 
                ? 'Internal Server Error. Please contact support'
                : 'Message: ' + response.data.message;
              swal({
                title: '500: Internal Server Error',
                icon: 'error',
                text: alertText,
                // timer: 2000,
                // showConfirmButton: false
              });
            } else {
              console.error('');
              console.error('Error');
              console.error(err);
              console.error(err.response);
              console.error('');
              // swal({
              //     title: 'Oops!',
              //     icon: 'error',
              //     text: 'Uncaught Error. Please contact an administrator',
              //     // timer: 2000,
              //     // showConfirmButton: false
              // });
            }
          });
      },

      /*
      --  Get Data Object --
          this function grabs all of the date passed into this vue instance from the blade template. See top of blade file where this instance is included to see where this data is pulled from

      */
      getDataObject() {

        return new Promise((resolve, reject) => {
          try {
            const vm = this;
            let dataObject = getDataObject();

            if(dataObject.selected_user){
              vm.changeSelectedUser(dataObject.selected_user);
            }

            if(dataObject.savedSearch){
              vm.updateSavedPropertySearch(dataObject.savedSearch);
            }
                        

            if(dataObject.searchType){
              vm.updateSearchType(dataObject.searchType);
              /**
               * If the search type is for-rent, 
               * -- and 
               * ---- No saved search is active for the page, 
               * ---- OR the active saved search does not have any building types associated with it
               */
              if(dataObject.searchType == 'for-rent' && (!dataObject.savedSearch?.id || !dataObject.savedSearch.building_types.length)){
                vm.updateSearchParams({building_types: []})
              }
            }

            if(dataObject.selectedLocation){

              /*
              *   This next line is hacky, but it was a quick way to 
              *   give the location select dropdown the text parameter it looks for when populating the initial selection
              */
              if(dataObject.selectedLocation.loc_level == 'zipcode'){
                dataObject.selectedLocation.text = dataObject.selectedLocation.id + ' - ' + dataObject.selectedLocation.name;
              } else {
                dataObject.selectedLocation.text = dataObject.selectedLocation.name;
              }
              this.updateSelectedLocation(dataObject.selectedLocation);

            } else {
              vm.changeLoading(false);
            }

            resolve(dataObject);
          } catch(e) {
            reject(e);
          }
                    
        });
                
                
                
      },
            
      /*
      --  Redirect if Logged Out --
      */
      redirectIfLoggedOut() {
        let selected_user = this.selected_user;
        if(selected_user == '' || !parseInt(selected_user)){
          window.location = '/login';
        }
      },


      /*
      --  Scroll to the top of the page --
      */
      scrollToTopOfPage(){
        window.scrollTo(0,0);
      },
            
      /*
      --  Remove active filter --
      */
      onFilterClick(field){

        /**
         * @ToDo Need a better way to handle this...
         * boolean fields should be set to false, not ''
         */
        let val = field.indexOf('has_') == 0 ? false : '';
        let params = {[field]: val};
        
        this.changeLoading(true);
        if(field.indexOf('zipcode_') == 0){
          let parts = field.split('_');
          let zipcode = parts[1];
          let newZipcodes = this.searchParams.selected_zipcodes.filter(zip => zip !== zipcode);
          this.selected_zipcodes = newZipcodes;
          params = {selected_zipcodes: newZipcodes};
        }
        this.changeSearchParams(params)
          .then(() => {
            // console.log($event, response);
            this.loadNewProperties({resetPage: true});
          })
          .catch((error) => {
            console.warn(error);
          });
      },

      /*
      --  Filter drawer "Reset Filter" clicked --
      */
      onFilterDrawerReset(params){
        this.changeLoading(true);
        this.changeSearchParams(params)
          .then(() => {
            // console.log($event, response);
            this.loadNewProperties({resetPage: true});
          })
          .catch((error) => {
            console.warn(error);
          });
      },

      onScroll: _.debounce(function($event){
        /**
         * do not do this on landscape orientation
         */
        if(window.innerWidth >= 992) return false;
        
        var scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
        var headerHeight = 55; // at time of writing this, it is explicitly set in the CSS
        if(scrollTop >= this.mainHeaderHeight){
          this.$refs.searchSpacerGap.style.height = this.mainHeaderHeight + 'px';
          this.$refs.filterBar.classList.add('fixed');
          this.showFilterBarCount = true;
        } else{
          this.$refs.searchSpacerGap.style.height = 0;
          this.$refs.filterBar.classList.remove('fixed');
          this.showFilterBarCount = false;
        }
      }, 5),
      
      onFilterChange($event){

        let name = Object.keys($event)[0];
        let value = Object.values($event)[0];
        let convertedValue = convertField(fieldTypes, name, value, false);

        if([value, convertedValue].includes(this.searchParams[name])) {
          return false;
        }
        
        this.changeSearchParams($event)
          .then(() => {
            this.loadNewProperties({resetPage: true});
          })
          .catch((error) => {
            console.warn(error);
          });
      },

      /*
      --  Filter Update Handler --
      -- -- Should NOT trigger fetching of new properties
      */
      onFilterUpdate($event){
        this.changeSearchParams($event).catch((error) => console.warn(error));
      },
            
      /*
      --  Show or hide the "More Filters" drawer --
      */
      toggleShowMoreFilters(){
        let action = 'Close';
        document.querySelector('body').classList.toggle('rwps-filter-drawer-shown');
        this.showFilterDrawer *= -1;
        if(this.showFilterDrawer == 1) {
          action = 'Open';
          setTimeout(() => {
            document.getElementById('rwps__filter-drawer__anchor-point').focus();
          }, 200);
          console.log('focusing');
        }
        window.sendClickEvent({
          category: 'Behavior Tracking - Search - More Filters',
          action
        });
      },

      /*
      --  Expand or collapse the results --
      */
      toggleResultsExpanded(){
        document.querySelector('body').classList.toggle('rwps-results-expanded');
        $('.rwps__results__expand-toggle').tooltip('hide');
        this.resultsExpanded *= -1;
        window.sendClickEvent({
          category: 'Behavior Tracking - Search - Expand Results',
          action: this.resultsExpanded ? 'Open' : 'Close'
        });
      },

      setInitialBounds(bounds){
        
      },

      onInitialBoundsSet(bounds){
        if(!bounds) {console.warn('onInitialBoundsSet :: invalid bounds'); return false; }
        this.changeBoundsSearchParams(bounds)
          .then(() => {})
          .catch(() => {
            // @ToDo: map tried to initialize withoutbounds
          });
        if(!this.initialized) this.loadNewProperties({initial: true}); // this is the initial request, make sure the loc_cd is sent with the API request so that the API knows to log the request to the DB
      },

      /*
      *  The zoom level determines what marker to show (price or no price) -- this is how the zoom level stays updayted
      *  TODO: Improve \ remove this 
      */
      onZoomChange(zoom){
        console.log('onZoomChange: ', zoom);
        if(!zoom || isNaN(zoom)) return false;
        // this.changeLoading(true);
        // // when the map STARTS to zoom, clear the markers (improves performance greatly)
        // this.updateMarkers([]);
        this.updateMapConfigZoom(zoom);
      },

      onDragStart(){
        console.log('onDragStart');

        /**
        * Come back to this
        */
        // this.updateLocationChanging(true);
                
        // when the map STARTS to drag, clear the markers (improves performance greatly)
        this.changeLoading(true);
        this.clearHighlightedProperty();
        // this.updateMarkers([]);
        window.sendClickEvent({
          category: 'Behavior Tracking - Search - Drag Start',
          action: this.selectedLocation.name || ''
        });
      },

      onDragEnd($event){

        const {center} = $event;

        if(!center) { console.trace(); return false; }
                
        let lat = center.lat();
        let lng = center.lng();

        this.updateMapConfig( { center: { lat, lng } });
      },

      adjustLayoutHeights: _.debounce(function(){
        const SITE_HEADER = document.querySelector('header.main-header');
        // const PHOTO_CARDS_WRAPPER = document.querySelector('.rwps__results .property-photo-cards-wrapper');
        const RESULTS_HEADER = document.querySelector('.rwps__results__header');
        const FILTER_BAR = document.querySelector('.rwps__filter-bar');
        const FILTER_DRAWER = document.querySelector('.rwps__filter-drawer');
        const SCROLL_WRAPPER = document.querySelector('.rwps__results__scroll-wrapper');
        const RWPS = document.querySelector('.rwps');
        const GLOBAL_ALERT = document.querySelector('.rw-global-alert');
        let globalAlertHeight = 0;
        if(GLOBAL_ALERT){
          globalAlertHeight = GLOBAL_ALERT.clientHeight;
        }
        let filterBarHeight = FILTER_BAR.clientHeight;
        let rwpsHeight = (window.innerHeight - SITE_HEADER.clientHeight - filterBarHeight - globalAlertHeight) - 2; // the decimal point pixel heights make this slightly off.. need to account for that
        let innerResultsHeight = window.innerHeight - SITE_HEADER.clientHeight - filterBarHeight - RESULTS_HEADER.clientHeight - globalAlertHeight;
        // if(!SITE_HEADER || PHOTO_CARDS_WRAPPER || !RESULTS_HEADER || !FILTER_BAR) console.error('missing element in layout height recalc'); return false;
        // console.log('site header', SITE_HEADER.clientHeight);
        // console.log('photo cards wrapper', PHOTO_CARDS_WRAPPER.clientHeight);
        // console.log('results header', RESULTS_HEADER.clientHeight);
        // console.log('filter bar', FILTER_BAR.clientHeight);
        // console.log('filter drawer', FILTER_DRAWER.clientHeight);
        // console.log(window.innerHeight);
        // console.log('');
        // console.log(innerResultsHeight);
        

        if(window.outerWidth < 992){
          // RWPS.style.paddingTop = `${filterBarHeight}px`;
        } else {
          SCROLL_WRAPPER.style.height = `${innerResultsHeight}px`;
          RWPS.style.height = `${rwpsHeight}px`;
          FILTER_DRAWER.style.height = `${rwpsHeight}px`;
        }

        // FILTER_DRAWER.style.height = `${innerResultsHeight}px`;
        // FILTER_DRAWER.style.top = `${RESULTS_HEADER.clientHeight}px`;
      }, 10),
            
      onSortChange(value){
        let parts = value.split('__');
        if(parts.length !== 2) {console.error('invalid sort value'); return false;}
        let order_by = parts[0];
        if(order_by == 'price') { 
          // This is needed because for rentals, we need to send `rent_amt`, and for sale properties we need to send `asking_price`
          order_by = this.searchType == 'for-sale' ? 'asking_price' : 'rent_amt';
        }
        let order_dir = parts[1];
        this.changeSearchParams({order_by, order_dir})
          .then(() => {
            // console.log($event, response);
            this.loadNewProperties({});
          })
          .catch((error) => {
            console.warn(error);
          });

        window.sendClickEvent({
          category: 'Behavior Tracking - Search - Sort Change',
          action: `${order_by} - ${order_dir}`
        });

      },
            
      onUpdateFilterDrawerActiveCount(value){
        this.filterDrawerActiveCount = value;
      },
            
      onMarkerClick(property){
        console.log(property);
        if(!property || !property.id) { console.warn('onMarkerClick ::invalid property'); return false; }
        window.sendClickEvent({
          category: 'Behavior Tracking - Search - Marker Click',
          action: this.searchType
        });
        if(this.searchType == 'for-sale'){
          window.open(
            `/mls-listings/${property.id}`,
            '_blank' // <- This is what makes it open in a new window.
          );
          return false;
        } else {
          window.open(
            `/rental-listings/${property.id}`,
            '_blank' // <- This is what makes it open in a new window.
          );
          return false;
        }
      },

      onMarkerTouchend($event){

        if(this.highlightedProperty.id) {
          this.clearHighlightedProperty();
          return false;
        }
        this.onHighlightProperty($event);
                
      },
            
      goToPage(page){
        this.changeLoading(true);
        this.scrollResultsToTop();
        this.changeSearchParams({page})
          .then(() => {
            // console.log($event, response);
            this.loadNewProperties({});
          })
          .catch((error) => {
            console.warn(error);
          });
      },

            
      scrollResultsToTop(){
        document.querySelector('.rwps__results__scroll-wrapper').scrollTop = 0;
      },
            
  
            
      onMapViewToggle(){

        this.changeMapView();
        if(this.mapView){
          this.updateMapConfig({draggable: true});
        } else {
          this.updateMapConfig({draggable: false});
          this.scrollResultsToTop();
        }

        window.sendClickEvent({
          category: 'Behavior Tracking - Search - Mobile Actions Bar',
          action: 'Toggle Map'
        });
                
      },
            
      changePageTitleNoLocation(searchType){

        let text = searchType == 'for-sale' 
            ? 'Investment Properties for Sale'
            : 'Homes for Rent ';
          document.title = `${text} | Renters Warehouse`;
      },
            
      changePageTitle({locationText, searchType}){

        if(locationText){
          let location = `${locationText}`;
          let ending = searchType == 'for-sale' 
            ? 'Investment Properties for Sale'
            : 'Homes for Rent ';
          document.title = `${location} ${ending} | Renters Warehouse`;
                
        } else {
          console.warn('Tried to change page title with invalid location: ', location);
        }
      },

      onCenterChange(e){
        this.updateMapConfig({center: e});
      },

      // onSelection(selection){
      //   const vm = this;
      //   if(!selection.place_id){
      //     console.error('invalid selection');
      //     return false;
      //   }

      //   googlePlacesAPI.getPlacesDetails({ placeId: selection.place_id })
      //     .then(res => {
      //       console.log(res);
      //       console.log(coords);
      //       let locationText = selection.description;
      //       let coords = res.data.result.geometry.location;
      //       window.location = window.baseURL + `/search-properties/for-sale?lat=${coords.lat}&lng=${coords.lng}&location_txt=${locationText}`;

      //       return false;
      //     })
      //     .catch(err => {
      //       console.warn(err);
      //     });

      // }
    
      openSavedSearchCTAModal(){
        $(this.$refs.savedSearchCtaModal).modal('show');
        this.savedSearchCTASetCookie();
        this.shownSavedSearchCTA = true;
      },

      savedSearchCTASetCookie(){
        // expires in two weeks: 60 seconds x 60 minutes x 24 hours x 14 days
        // we'll look at the math behind this in the next section
        document.cookie = `saved_search_cta=shown; path=/; max-age=${60 * 60 * 24 * 14};`;
      },

      savedSearchCTAOptOut(){
        // has no expiration date. will not expire unless cleared
        document.cookie = `saved_search_cta=opt-out; path=/;`;
        $(this.$refs.savedSearchCtaModal).modal('hide');
      }

      

      
    },
    watch: {
      savedPropertySearchTitle(){
        if(this.storingSavedPropertySearch) this.storingSavedPropertySearch = false;
      }
    },
    
  });
    
}
